var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-page',[_c('div',{attrs:{"id":"contents"}},[_c('v-container',[_c('div',{staticClass:"title-wrap title-wrap--line"},[_c('h2',{staticClass:"font-42"},[_vm._v("어바웃 게시판")])]),_c('div',[_c('h2',[_vm._v("1 section 회사소개(고정 이미지)")])]),_c('about-list'),_c('div',[_c('h2',[_vm._v("오시는 길(고정 이미지)")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }